import React from "react";

import { useFeatureFlag } from "@/hooks/useFeatureFlag";

import { TFeatureFlag } from "@/types";

/**
 * Renders its children only when the feature is on for the user - off,
 * nothing at all, not even a hint. Whether the plan allows it is
 * PlanGate's question, asked after this one.
 */
export const FeatureGate: React.FC<{
	feature: TFeatureFlag;
	children: React.ReactNode;
}> = ({ feature, children }) =>
	useFeatureFlag(feature) ? <>{children}</> : null;
